(function ($) {


	/*-------------------------------------------
	アコーディオン
	-------------------------------------------*/
	$(function () {
		$('.acdbtn').on('click', function () {
			$(this).next().slideToggle();
			$(this).toggleClass('is-open');
		});
	});

	/*-------------------------------------------
	popup
	-------------------------------------------*/
	$(function () {
		var scrollpos;
		$('.popup-youtube').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false,
			callbacks: {
				open: function () {
					var popdom = $.magnificPopup.instance.content;
					popscrollpos = $(window).scrollTop();
					$('body').addClass('fixed').css({
						'top': -popscrollpos
					});
				},
				close: function () {
					$('body').removeClass('fixed').css({
						'top': 0
					});
					window.scrollTo(0, popscrollpos);
				},
			}
		});
	});

	/*-------------------------------------------
	 smooth scroll
	 -------------------------------------------*/
	$(function () {
		var headerHeight = $('#header').outerHeight();
		var urlHash = location.hash;
		if (urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function () {
				var target = $(urlHash);
				var position = target.offset().top - headerHeight;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
		}
		$('a[href^="#"]').click(function () {
			var target = $(this.hash);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
			return false;
		});
	});


	/*
	 * css swicher
	 */
	function css_browser_selector(u) {
		var ua = u.toLowerCase(),
			is = function (t) {
				return ua.indexOf(t) > -1
			},
			e = 'edge',
			g = 'gecko',
			w = 'webkit',
			s = 'safari',
			o = 'opera',
			m = 'mobile',
			h = document.documentElement,
			b = [
				(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) :
				!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua) ? ('ie ie' + RegExp.$1) :
				is('edge/') ? e :
				is('firefox/2') ? g + ' ff2' :
				is('firefox/3.5') ? g + ' ff3 ff3_5' :
				is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' :
				is('gecko/') ? g :
				is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
					(/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
				is('konqueror') ? 'konqueror' :
				is('blackberry') ? m + ' blackberry' :
				is('android') ? m + ' android' :
				is('chrome') ? w + ' chrome' :
				is('iron') ? w + ' iron' :
				is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') :
				is('mozilla/') ? g :
				'',
				is('j2me') ? m + ' j2me' :
				is('iphone') ? m + ' iphone' :
				is('ipod') ? m + ' ipod' :
				is('ipad') ? m + ' ipad' :
				is('mac') ? 'mac' :
				is('darwin') ? 'mac' :
				is('webtv') ? 'webtv' :
				is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
				is('freebsd') ? 'freebsd' :
				(is('x11') || is('linux')) ? 'linux' :
				'',
				'js'
			];
		c = b.join(' ');
		h.className += ' ' + c;
		return c;
	};
	css_browser_selector(navigator.userAgent);

})(jQuery);